import { Button } from 'antd'
import { isNil } from 'lodash'

import { pick } from '@eastcoal/common/utils/object'

import { FormMode } from '@eastcoal/formily/components/CrudForm/enums/FormMode'

import { AuctionOperationPageStatus } from '../../../enums/AuctionOperationPageStatus'
import { useAuctionListStore } from '../../../Store/hooks/useStore'

import { AbortiveExplainCreateButtonProps } from './interface'

export const AbortiveExplainCreateButton = ({
  record
}: AbortiveExplainCreateButtonProps) => {
  const {
    setCurrentAuction,
    setAbortiveExplainFormMode,
    toggleAbortiveExplainVisible
  } = useAuctionListStore(state =>
    pick(state, [
      'setCurrentAuction',
      'setAbortiveExplainFormMode',
      'toggleAbortiveExplainVisible'
    ])
  )

  const handleClick = () => {
    setCurrentAuction(record)
    setAbortiveExplainFormMode(FormMode.UPDATE)
    toggleAbortiveExplainVisible(true)
  }

  return isNil(record.explainStatus) &&
    record.status === AuctionOperationPageStatus.DEAL_FAIL ? (
    <Button type='link' onClick={handleClick}>
      生成说明
    </Button>
  ) : null
}
